import { NgModule } from '@angular/core';
import { SbeServiceLibComponent } from './sbe-service-lib.component';
import { TelemetryGeneratorService } from './telemetry/telemetry-generator.service';
import { UtilityService } from './common/utility.service';

@NgModule({
  declarations: [SbeServiceLibComponent],
  imports: [
    
  ],
  exports: [SbeServiceLibComponent],
  providers: [
    TelemetryGeneratorService,
    UtilityService
  ]
})
export class SbeServiceLibModule { }
